/// <amd-module name="CodeCoverage/Common/Actions/CodeCoverageActionCreator" />
import { CodeCoverageActionHub } from 'CodeCoverage/Common/Actions/CodeCoverageActionHub';
import { GetCodeCoverageTimelineSummaryData } from 'CodeCoverage/Common/Common';
import { RunViewArtifact } from 'CodeCoverage/Common/RunViewArtifact';
import { CodeCoverageSource } from 'CodeCoverage/Common/Sources/CodeCoverageSource';
import { IVssComponentContext } from 'VSS/Platform/Layout';

export class CodeCoverageActionCreator {
    constructor(private _actionHub: CodeCoverageActionHub, private pageContext: IVssComponentContext) {
        this._source = CodeCoverageSource.getInstance(pageContext)
    }

    public fetchCodeCoverageSummary(buildArtifact: RunViewArtifact) {
        GetCodeCoverageTimelineSummaryData(buildArtifact, this._source).then((timelineSummaryData) => {
            if (timelineSummaryData && timelineSummaryData.length) {
                this._actionHub.initializeCodeCodeCoverageSummary.invoke({ timelineSummaryData });
            }
        });
    }
    
    private _source: CodeCoverageSource;
}
